import React, { useEffect } from 'react';
import Cookie from 'js-cookie';
import { CloseIcon } from '@bizzabo/icons';
import BZModal from 'BZModal';
import { connect } from 'react-redux';

import { ssoEmailErrorModalSelector } from '../../selectors/LoginSelectors';
import { hideSsoEmailErrorModal, showSsoEmailErrorModal } from '../../actions/LoginActions';
import { renderReactComponentWithRedux } from '../../hocs/withReduxProvider';
import { COOKIE_UNREGISTERED_USER_EMAIL } from '../../constants/Enums';

const SsoEmailErrorModal = ({
    showSsoErrorModal,
    errorEmail,
    registrationsUrl,
    hideSsoEmailErrorModal,
    showSsoEmailErrorModal,
}) => {
    useEffect(() => {
        const unregisteredEmail = Cookie.get(COOKIE_UNREGISTERED_USER_EMAIL);
        if (unregisteredEmail) {
            showSsoEmailErrorModal(unregisteredEmail);
        }
        Cookie.remove(COOKIE_UNREGISTERED_USER_EMAIL);
    }, []);

    return (
        <BZModal
            modalCls="agenda-modal third-party-cookie-modal sso-email-error-modal"
            color='white'
            show={showSsoErrorModal}
            onHide={hideSsoEmailErrorModal}
            hideFooter
        >
            <button
                className="close-btn custom-color color-1-background color-1-hover-opacity"
                onClick={hideSsoEmailErrorModal}
            >
                <CloseIcon fill='#fff'/>
            </button>
            <div className="inner-container unregistered-modal">
                <div className="text-center">
                    <h4 className="modal-title font-size-20 margin-bottom-small">Unregistered Email Address</h4>
                    <div className="margin-bottom-large">
                        <p className="subtitle font-size-14 margin-bottom-none">The email address <strong>{errorEmail}</strong></p>
                        <p className="subtitle font-size-14">is not registered for this event.</p>
                    </div>
                    <div className="margin-bottom-medium">
                        <a
                            href={registrationsUrl}
                            className="cta-button cta-button-large font-size-13 custom-color color-1-background color-1-hover-opacity"
                            target="_top"
                        >
                            Register now
                        </a>
                    </div>
                    <div>
                        <span>Need help? </span>
                        <a href="mailto:support@bizzabo.com?subject=Request assistance joining the event" className="modal-link custom-color"> Contact us</a>
                    </div>
                </div>
            </div>
        </BZModal>
    );
};

const SsoEmailErrorModalWithRedux = connect(
    ssoEmailErrorModalSelector,
    { hideSsoEmailErrorModal, showSsoEmailErrorModal }
)(SsoEmailErrorModal);

export const renderSsoEmailErrorModal = (props = null) => {
    renderReactComponentWithRedux(
        SsoEmailErrorModalWithRedux,
        document.getElementById('sso-email-error-popup'),
        props
    );
};

export default SsoEmailErrorModalWithRedux;
